import React from "react";
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import Icon from "../Utils/Icon";
import FormatDate from "../Utils/FormatDate";
import Loader from "../Utils/Loader";
import Help from "../Utils/Help";

import classes from './styles.module.css';

function PaymentsOnMonth({data, isLoading}) {
    return (
        <div className={classes.Card}>
            <div className={classes.CardHeader}>
                <h6>
                    <FormattedMessage
                        id="Dashboard.title.paymentsThisMonth"
                        defaultMessage="Платежи за {month}"
                        values={{
                            month: <FormatDate format={{month: 'long'}}/>
                        }}
                    />
                </h6>
            </div>

            {isLoading ? <Loader/> : (
                <div className={classes.CardBody}>
                    <div className={classes.MediaIcon}>
                        <Icon color={'#2479E0'} icon="calendar" size={'20px'}/>
                    </div>

                    <div className={classes.MediaBody}>
                        <h2>{data.payout.count + data.purchase.count + data.recurrent.count}</h2>

                        <Help width={120}>
                            <div>
                                <FormattedMessage
                                    id="Dashboard.help.payout"
                                    defaultMessage="Выплаты: {count}"
                                    values={{count: data.payout.count}}
                                />
                            </div>
                            <div>
                                <FormattedMessage
                                    id="Dashboard.help.purchase"
                                    defaultMessage="Покупки: {count}"
                                    values={{count: data.purchase.count}}
                                />
                            </div>
                            <div>
                                <FormattedMessage
                                    id="Dashboard.help.recurrent"
                                    defaultMessage="Рекуррентные: {count}"
                                    values={{count: data.recurrent.count}}
                                />
                            </div>
                        </Help>

                        <div className={classes.MediaMore}>
                            <div className={classes.Desc}>
                                <FormattedMessage id="Dashboard.title.successful" defaultMessage="Успешных"/>
                            </div>

                            <div>
                                <Link className={classes.Link} to={'/transactions/{"period": "month"}'}>
                                    <Icon className={classes.Icon} icon="pie-chart" size={'18px'}/>
                                    <span>
                                    <FormattedMessage id="Dashboard.title.statistics" defaultMessage="Статистика"/>
                  </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PaymentsOnMonth;



// WEBPACK FOOTER //
// ./src/Components/PaymentsOnMonth/index.js